module.exports = __webpack_public_path__ + "static/media/orthoUploaderIcon.88ed92f8.svg";